import { graphql } from "gatsby";
import React from "react";
import Layout from "../../../components/Layout";
import RelatedServices from "../../../components/RelatedServices/RelatedServices";
import VideoPanel from "../../../components/VideoPanel/VideoPanel";

const styles = require("./howItWorks.module.scss");

const HowItWorksPage = ({
  data: {
    pageData,
    pageData: { video, heading, articles, topics, client_types, filter_types },
  },
}) => {
  return (
    <Layout>
      <section class={styles.videoWrapper}>
        <h2>{heading}</h2>
        <div class={styles.videoPanel}>
          <VideoPanel videoData={video} />
        </div>
      </section>
      <RelatedServices
        topics={topics}
        client_types={client_types}
        tagTypes={filter_types}
        articlesData={articles}
      />
    </Layout>
  );
};

export default HowItWorksPage;

export const query = graphql`
  query GetHowItWorksPage($slug: String) {
    pageData: strapiAmxZeroHowItWorks(slug: { eq: $slug }) {
      heading
      slug
      metaData {
        pageTitle
        metadescription
      }
      topics {
        id
        type
      }

      filter_types {
        type
      }
      client_types {
        id
        Type
      }
      articles {
        articlesHeading
        insights {
          id
        }
        case_studies {
          id
        }
        press_releases {
          id
        }
        events {
          id
        }
      }
      video {
        video {
          localFile {
            publicURL
          }
        }
        poster {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1440)
            }
          }
        }
        transcript {
          localFile {
            id
            publicURL
          }
        }
      }
    }
  }
`;
